export { QuotaLeftText } from './QuotaLeftText';
